import React from 'react';

import Typography from '../../../../../../../../components/atomic/Typography';
import { useStyles } from './style';

export function EstimateTitleWithPopup() {
  const classes = useStyles();

  return (
    <Typography variant="h2" className={classes.hjemlaEstimateTitle}>
      Verdiestimat
    </Typography>
  );
}
